var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Dependencies } from "~/core/decorator";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { LabelingStrategyService } from "~/services/dataimp-service/labeling-strategy-service";
import RunRecordOfTheDay from "~/components/labeling-strategy/run-record-of-the-day.vue";
var CollectionExecutionModule = namespace("collection-execution");
var RunningRecordSummary = /** @class */ (function (_super) {
    __extends(RunningRecordSummary, _super);
    function RunningRecordSummary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            runningTime: [],
            id: ""
        };
        _this.batchNumber = "";
        _this.labelId = "";
        _this.dialog = {
            RunRecordOfTheDaydialog: false
        };
        _this.dataSet = [];
        return _this;
    }
    RunningRecordSummary.prototype.onIdChange = function (val) {
        // if (val) this.refreshData();
    };
    RunningRecordSummary.prototype.mounted = function () {
        // this.refreshData();
    };
    RunningRecordSummary.prototype.checkDetailsClick = function (scope) {
        this.batchNumber = scope.row.batchNumber;
        this.labelId = scope.row.labelId;
        this.dialog.RunRecordOfTheDaydialog = true;
    };
    RunningRecordSummary.prototype.refreshData = function () {
        var _this = this;
        this.model.id = this.id;
        this.labelingStrategyService
            .queryLabelDetailAll(this.model, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        CollectionExecutionModule.State
    ], RunningRecordSummary.prototype, "executionId", void 0);
    __decorate([
        Dependencies(LabelingStrategyService)
    ], RunningRecordSummary.prototype, "labelingStrategyService", void 0);
    __decorate([
        Dependencies(PageService)
    ], RunningRecordSummary.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], RunningRecordSummary.prototype, "sortService", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], RunningRecordSummary.prototype, "id", void 0);
    __decorate([
        Watch("id")
    ], RunningRecordSummary.prototype, "onIdChange", null);
    RunningRecordSummary = __decorate([
        Component({
            components: {
                RunRecordOfTheDay: RunRecordOfTheDay
            }
        })
    ], RunningRecordSummary);
    return RunningRecordSummary;
}(Vue));
export default RunningRecordSummary;
